var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoodIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 21C0 21.54 0.45 22 1 22H14C14.56 22 15 21.54 15 21V20H0V21ZM7.5 8C3.75 8 0 10 0 14H15C15 10 11.25 8 7.5 8ZM2.62 12C3.73 10.45 6.09 10 7.5 10C8.91 10 11.27 10.45 12.38 12H2.62ZM0 16H15V18H0V16ZM17 4V0H15V4H10L10.23 6H19.79L18.39 20H17V22H18.72C19.56 22 20.25 21.35 20.35 20.53L22 4H17Z",
    fill: "#FDFDFD",
    fillOpacity: 0.992157
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodIcon);
export default __webpack_public_path__ + "static/media/food-icon.cff820139b5646efdf411a33fe012952.svg";
export { ForwardRef as ReactComponent };